import React from 'react';
import { InfoCardList } from '../../../../components';
import { DocumentationCard } from '../documentation-card/DocumentationCard';
import { SystemMessagesCard } from '../system-messages-card/SystemMessagesCard';
import { SystemStatusCard } from '../system-status-card/SystemStatusCard';

export const DashboardCardHeader = (): React.JSX.Element => {
    return (
        <InfoCardList>
            <SystemMessagesCard />
            <DocumentationCard />
            <SystemStatusCard />
        </InfoCardList>
    );
};
